const env = Object.assign({}, process.env);

export default {
    main: {
        endpoint: env.VUE_APP_MAIN_ENDPOINT,
        staticEndpoint: env.VUE_APP_MAIN_STATICENDPOIN
    },
    sentry: {
        dsn: env.VUE_APP_SENTRY_DSN,
        app: env.VUE_APP_SENTRY_APP
    },
    zpusher: {
        endpoint: env.VUE_APP_ZPUSHER_ENDPOINT,
        key: env.VUE_APP_ZPUSHER_KEY
    },
    pusher: {
        key: env.VUE_APP_PUSHER_KEY,
        cluster: env.VUE_APP_PUSHER_CLUSTER,
    },
    addresses: {
        types: {
            LEGAL_ADDRESS_TYPE_ID:   env.VUE_APP_ADDRESSES_LEGAL_TYPE,   //юридический адрес
            ACTUAL_ADDRESS_TYPE_ID:  env.VUE_APP_ADDRESSES_ACTIAL_TYPE,  //фактический адрес
            MAILING_ADDRESS_TYPE_ID: env.VUE_APP_ADDRESSES_MAILING_TYPE, //почтовый адрес
        }
    },
    other: {
        menuDocsLink: env.VUE_APP_OTHER_MENU_DOCLINK,
        menuVersionLink: env.VUE_APP_OTHER_MENU_VERLINK
    }
}


// WEBPACK FOOTER //
// ./src/config.js